<div class="main-content">
  <app-header [title]="'HEADER.TITLE_ANALYTICS' | translate" [subtitle]="'HEADER.SUBTITLE_ANALYTICS' | translate" />

  <div class="col-12" style="margin-top: 5rem">
    <app-icam-container [iconName]="'analytics'" iconHeight="24px">
      <app-filters
        [fields]="filterFields"
        [canOrder]="false"
        [translateOptions]="false"
        [initialFilters]="initialFilters"
        (selectedFilters)="onFiltersSelected($event)"
        (resetFilters)="onResetFilters()"
      ></app-filters>

      <div class="analytics-data-container">
        <app-icam-tabs
          [tabs]="tabItems"
          [selectedTabId]="selectedTabId"
          [showArrow]="true"
          [spaced]="false"
          (tabChange)="onTabChange($event)"
        ></app-icam-tabs>

        <div class="tab-view-container">
          @if (activeComponent) {
            <ng-container
              [ngComponentOutlet]="activeComponent"
              [ngComponentOutletInputs]="{ filters: filters$ | async }"
            ></ng-container>
          }
        </div>
      </div>
    </app-icam-container>
  </div>
</div>
